const getPageLabel = (): string => {
  const currentLocationPath = window.location.pathname;

  switch (true) {
    case /\/hotels\/manage\/bookings\/.{36}\/print/.test(currentLocationPath):
      return 'QSS Print View Page';
    case /\/hotels\/manage\/bookings\/.{36}\/cancellation-quote/.test(currentLocationPath):
      return 'QSS Cancel Booking Page';
    case /\/hotels\/manage\/bookings\/.{36}\/change-date-request/.test(currentLocationPath):
      return 'QSS Change Dates Request Page';
    case /\/hotels\/manage\/bookings\/.{36}\/update-payment-method/.test(currentLocationPath):
      return 'QSS Update Payment Method Page';
    case /\/hotels\/manage\/bookings\/.{36}\/change-date/.test(currentLocationPath):
      return 'QSS Change Dates Page';
    case /\/hotels\/manage\/bookings\/.{36}/.test(currentLocationPath):
      return 'QSS Booking Details Page';
    case /\/hotels\/manage\/bookings$/.test(currentLocationPath):
      return 'QSS Booking List Page';
    default:
      return 'QSS';
  }
};

export default getPageLabel;
